import {
  RESET_SYSTEM_USERS,
  RESET_SYSTEM_USER,
  RESET_ERROR,
  GET_SYSTEM_USERS,
  SET_SYSTEM_USERS,
  API_ERROR,
  GET_SYSTEM_USER,
  SET_SYSTEM_USER,
  CREATE_SYSTEM_USER,
  CREATE_SYSTEM_USER_SUCCESS,
  EDIT_SYSTEM_USER,
  EDIT_SYSTEM_USER_SUCCESS,
  ACTIVATE_SYSTEM_USER,
  ACTIVATE_SYSTEM_USER_SUCCESS,
} from "./actionTypes";

export const resetSystemUsers = () => {
  return {
    type: RESET_SYSTEM_USERS,
    payload: {},
  };
};

export const resetSystemUser = () => {
  return {
    type: RESET_SYSTEM_USER,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getSystemUsers = (page, qnt, name, email, nickname) => {
  return {
    type: GET_SYSTEM_USERS,
    payload: { page, qnt, name, email, nickname },
  };
};
export const setSystemUsers = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_SYSTEM_USERS,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createSystemUser = (newSystemUserValues) => {
  return {
    type: CREATE_SYSTEM_USER,
    payload: { newSystemUserValues },
  };
};
export const createSystemUserSuccess = (message) => {
  return {
    type: CREATE_SYSTEM_USER_SUCCESS,
    payload: { message },
  };
};

export const getSystemUser = (idSystemUser, isForm) => {
  return {
    type: GET_SYSTEM_USER,
    payload: { idSystemUser, isForm },
  };
};
export const setSystemUser = (data) => {
  return {
    type: SET_SYSTEM_USER,
    payload: { data },
  };
};

export const editSystemUser = (idSystemUser, newSystemUserValues) => {
  return {
    type: EDIT_SYSTEM_USER,
    payload: { idSystemUser, newSystemUserValues },
  };
};
export const editSystemUserSuccess = (message) => {
  return {
    type: EDIT_SYSTEM_USER_SUCCESS,
    payload: { message },
  };
};

export const activateSystemUser = (idSystemUser, active) => {
  return {
    type: ACTIVATE_SYSTEM_USER,
    payload: { idSystemUser, active },
  };
};
export const activateSystemUserSuccess = (message) => {
  return {
    type: ACTIVATE_SYSTEM_USER_SUCCESS,
    payload: { message },
  };
};
